export enum View {
    LIST = 'list',
    CALENDAR = 'calendar',
    CARDS = 'cards',
    MAP = 'map',
}
